export default (props: any) => {
    return (
        <div className={`flex flex-col w-auto rounded-lg shadow-md shadow-black border border-slate-800 p-4 gap-5 hover:cursor-pointer ${props.className}`}>
            {props.children}
        </div>
    )
}